export const SERP_QUERY_PARAMS_NAMES = {
  phrase: 'phrase',
  products: 'products',
  platforms: 'serp-platform',
  withTranslate: 'with-translate',
  shadowInput: 'shadow',
};

export const MIN_SEARCH_PHRASE_FOR_SEARCH = 2;
